import React, { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { Row, Col, Card } from "react-bootstrap";
import Constants from "../../../common/Constants";
import { useTranslation } from "react-i18next";
import Badge from "react-bootstrap/Badge";
import ItemService from "../../../services/commonService";
// import moment from "moment";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  capitalizeFirstWord,
  formatDateTime,
} from "../../../common/Validations";
import Loader from "../../../common/Loader";
import TooltipList from "../../../components/common/TooltipList";

const OverviewMachines = () => {
  const props = useLocation();
  const { deptCode } = props.state || ""; // Destructure the state
  const navigate = useNavigate();
  const [machinesData, setMachinesData] = useState([]);
  const [loaderStatus, setLoaderStatus] = useState(false);

  const fetchMachinesByDept = async () => {
    let param = {};
    param.url = "getMachineJobcardDataByDeptId";
    param.page = Constants.MASTER.MACHINES.name;
    param.id = deptCode;
    // console.log(">>> Inside machine method");
    await ItemService.getMachineJobcardDataByDeptId(param).then((item) => {
      if (item?.status === 200) {
        setMachinesData(item?.data);
      } else {
      }
      setLoaderStatus(false);
    });
  };

  useEffect(() => {
    setLoaderStatus(true);
    fetchMachinesByDept();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { t } = useTranslation();
  const navigateBack = () => {
    navigate("/overview");
  };
  return (
    <main className="dashboard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <Button
              type="button"
              variant="primary"
              className="btn btn-primary btn-xs navigateBackButton"
              onClick={() => navigateBack()}
            >
              <i className="bi bi-arrow-left back"> </i>
              <span className="back"> {t("msg_common.Back")}</span>
            </Button>
            <h2 className="mainTitle">{"Machines Overview"}</h2>
            <hr />
          </div>
        </Col>
      </Row>
      <Row>
        <Loader isLoading={loaderStatus} className={"text-center"} />
        {machinesData?.map((val, index) => (
          <Col key={index} lg={3} md={4} sm={6}>
            <Card border="primary" className="overview-card">
              <Card.Header as="h5">
                {val.machineCode} - {val.machineName}
                {/* <span className="overview-card-header-value">10/0</span> */}
                {val.status === "Active" && val.runningStatus !== "Inuse" ? (
                  <span>
                    <Badge pill bg="" className="success-indicator">
                      {" "}
                    </Badge>
                  </span>
                ) : val.status === "Inactive" ||
                  val.runningStatus === "Inuse" ? (
                  <span>
                    <Badge pill bg="" className="error-indicator">
                      {" "}
                    </Badge>
                  </span>
                ) : (
                  <span>
                    <Badge pill bg="" className="success-indicator">
                      {" "}
                    </Badge>
                  </span>
                )}
              </Card.Header>

              <Card.Body>
                {/* <Card.Title>{card.title}</Card.Title>
                  <Card.Text>{card.text}</Card.Text> */}
                <Row className="card-body-row">
                  <Col lg={6} md={6} sm={6}>
                    <div className="dates">
                      <div className="machines-urgent">
                        {val?.sizeCode || "-"}
                        <strong>{"Size"}</strong>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={6}>
                    <div className="dates">
                      <div className="machines-urgent">
                        {val?.operatorUserName
                          ? val?.operatorUserName
                          : val?.idleOperatorUserName || "-"}
                        <strong>{"Operator"}</strong>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                {val?.idleTo === "" ? (
                  <>
                    <Row>
                      <Col
                        lg={4}
                        md={4}
                        sm={12}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <div className="machine-overview-footer">
                          <div className="machines-quantity text-danger">
                            {val?.idleFrom
                              ? formatDateTime(val?.idleFrom)
                              : "-"}
                            <strong>{"idle From"}</strong>
                          </div>
                        </div>
                      </Col>
                      <Col
                        lg={4}
                        md={4}
                        sm={12}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <div className="machine-overview-footer">
                          <div className="ok-quantity text-danger">
                            {val?.idleReasonName}
                            <strong>{"Status"}</strong>
                          </div>
                        </div>
                      </Col>
                      <Col
                        lg={4}
                        md={4}
                        sm={12}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <div className="machine-overview-footer">
                          <div className="text-danger">
                            {val?.remarksIdle}
                            <strong>{"Remarks"}</strong>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    <Row>
                      <Col
                        lg={4}
                        md={4}
                        sm={12}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <div className="machine-overview-footer">
                          <div className="machines-quantity">
                            {val?.jobcard
                              ? val?.jobcard
                              : val?.assignedJobCardList
                              ? val?.assignedJobCardList?.length > 0
                                ? <TooltipList key={index} text="Assigned - " items={val?.assignedJobCardList} />
                                : "-"
                              : "-"}
                            <strong>{"Job Card"}</strong>
                          </div>
                        </div>
                      </Col>
                      <Col
                        lg={4}
                        md={4}
                        sm={12}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <div className="machine-overview-footer">
                          <div className="ok-quantity text-success">
                             {val?.jobcardStatus ? (
                              <>
                                {val.jobcardStatus.toLowerCase() === "inprogress"
                                  ? "In Process"
                                  : capitalizeFirstWord(val.jobcardStatus)}
                              </>
                            ) : (
                              "-"
                            )}
                            <strong>{"Status"}</strong>
                          </div>
                        </div>
                      </Col>
                      <Col
                        lg={4}
                        md={4}
                        sm={12}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <div className="machine-overview-footer">
                          <div>
                            {val?.jobcard
                              ? val?.updatedDate
                                ? formatDateTime(val?.updatedDate)
                                : "-"
                              : "-"}

                            <strong>{"Time"}</strong>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
              </Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>
    </main>
  );
};

export default OverviewMachines;
